















import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'BaseNormalSoundButton'
})
export default class BaseNormalSoundButton extends Vue {
  playSound(this: any) {
    const audio: HTMLAudioElement = this.$refs.audio;

    audio.pause();
    audio.currentTime = 0;
    audio.play();
  }
}
